<template>
  <div class="listsinger mt-4">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Danh sách ca sĩ
        </h1>
      </div>

      <div class="right singeralphabet">
        <a class="p-2 font-weight-bold" v-for="(item, i) in alphaData"
           @click="getSingerByAlphabet(item.text)"
           :class="{ active : currentAlphabet === item.text }">{{ item.text }}</a>
      </div>
    </div>
    <div style="clear:both;"></div>

    <div class="row singlecontent mt-2">
      <div v-for="(item, i) in singerList.slice(0, 10)" class="item col-md-5ths" :class="{ 'text-left' : i%5 == 0, 'text-right' : (i+1)%5 == 0 }">
        <a :href="prefixUrl + item.id">
          <img :src="item.thumbnail != '' ? item.thumbnail : thumbnailDefault"/>
          <p class="song color-text">{{ item.singer }}</p>
        </a>
      </div>
    </div>

    <!--<pagination-2
      v-if="totalPage > 1"
      :total-pages="totalPage"
      :total="totalRecord"
      :per-page="15"
      :current-page="currentPage"
      @pagechanged="onPageChange"
      :previous-name="previousName"
      :next-name="nextName"
      class="mt-2 mb-4"
    >
    </pagination-2>-->
  </div>
</template>

<script>
  import Pagination2 from '../../Pagination2'

  export default {
    name: "ListSinger",
    components: {
      "pagination-2": Pagination2
    },
    data () {
      return {
        name: "",
        currentAlphabet: "A",
        alphaData: [
          {text: "A"}, {text: "B"}, {text: "C"}, {text: "D"}, {text: "E"}, {text: "F"}, {text: "G"}, {text: "H"}, {text: "I"}, {text: "J"},
          {text: "K"}, {text: "L"}, {text: "M"}, {text: "N"}, {text: "O"}, {text: "P"}, {text: "Q"}, {text: "R"}, {text: "S"}, {text: "T"},
          {text: "U"}, {text: "V"}, {text: "W"}, {text: "X"}, {text: "Y"}, {text: "Z"}
        ],

        singerList: [],
        thumbnailDefault: this.settings.defaultThumbnailSong,
        prefixUrl: this.settings.prefixSinger,

        currentPage: 1,
        totalRecord: 1,
        totalPage: 1,
        previousName: "previousArrow",
        nextName: "nextArrow",
      }
    },
    created () {
      this.name = this.$route.query.name;
      if(this.name && this.name != undefined){
        this.currentAlphabet = this.name;
      }
    },
    methods: {
      getSingerByAlphabet(alphabet){
        this.currentAlphabet = alphabet;
        this.$router.push({ path: this.$router.path, query: { name: alphabet } });
      },
      getListSinger(){
        var dataPost = {
          "alphabet": this.currentAlphabet,
          "pageSize": 15,
          "pageIndex": this.currentPage
        };

        axios.post(api.singerListByAlpha, dataPost)
          .then(response => {
            this.singerList = response.data.result;
            this.totalRecord = response.data.totalRecord;
            this.totalPage = response.data.totalPage;
          }).catch(error => {
          console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      }
    },
    watch: {
      'currentAlphabet': {
        handler: function (val) {
          this.getListSinger();
          this.currentPage = 1;
        },
        immediate: true
      },
      "currentPage": {
        handler: "getListSinger",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .singeralphabet a.active{
    color: #0d5bdd !important;
    font-size: 18px;
  }
  .singlecontent .item{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .singlecontent .item img{
    width: 200px;
    height: 200px;
  }
  .pagination{
    margin: 0 auto;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/singer/web/ListSinger.vue